import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from 'OpsCenter/shared/shared.module';
import { MerchantCleanUpComponent } from 'OpsCenter/ops-support/merchant-clean-up/merchant-clean-up.component';
import { MerchantCleanUpService } from 'OpsCenter/ops-support/merchant-clean-up/merchant-clean-up.service';


@NgModule({
  imports: [HttpClientModule, CommonModule, SharedModule, FormsModule],
  declarations: [MerchantCleanUpComponent],
  providers: [MerchantCleanUpService],
  entryComponents: [MerchantCleanUpComponent],
})
export class MerchantCleanUpModule {
}



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-clean-up/merchant-clean-up.module.ts